import { error } from "console";
import http from "../utils/http";
import { GETListResponse } from "./SubscriptionServices";

export interface ISendFreeBiesRequest {
  title: string;
  description: string;
  subscriptionId: string;
  attachmentUrl: string;
  status: string;
  id: string;
}
const GetAllSentFreeBiesRequest = async ({
  page,
  size,
}: {
  page: number;
  size: number;
}): Promise<GETListResponse<ISendFreeBiesRequest>> => {
  const urlPath = `/admin/freebies/list?size=${size}&page=${page - 1}`;

  const result = await http.get({ path: urlPath });
  if (result.status == 200) {
    return result.data as GETListResponse<ISendFreeBiesRequest>;
  } else {
    throw new Error(
      `Error fetching SendFreebies Requests: ${result.statusText}`
    );
  }
};

const GetSignUrlForFreeBiesPlanUpload = async ({
  name,
}: {
  name: string;
}): Promise<string> => {
  const urlPath = `/admin/freebies/upload-freebie?fileName=${name}`;
  const GetSignUrl = await http.get({ path: urlPath });

  if (GetSignUrl.status == 200 && (GetSignUrl.data.data as string)) {
    return GetSignUrl.data.data;
  } else {
    throw new Error(`Error fetching Sign Url : ${GetSignUrl.statusText}`);
  }
};

const SendFreeBie = async ({
  title,
  description,
  attachmentUrl,
  subscriptionId,
}: {
  title: string;
  description: string;
  attachmentUrl: string;
  subscriptionId: string;
}): Promise<number> => {
  const urlPath = `/admin/freebies`;
  const body = { title, description, attachmentUrl, subscriptionId };
  const result = await http.post({ path: urlPath, body });
  if (result.status == 201) {
    return 201;
  } else {
    return 400;
  }
};

export {
  GetAllSentFreeBiesRequest,
  SendFreeBie,
  GetSignUrlForFreeBiesPlanUpload,
};
